$(document).ready(function () {
    $(".header-bar-closeButton").click(function () {
        var url = $(this).data("url");
        $.ajax({
            url: url,
            method: "GET",
            success: function () {
                $(".header-bar").slideUp();
            }
        });
    });
    /* close banner loyalty programme */
    $(".header-bar-loyalty-closeButton").click(function () {
        var expiration = 864000;
        $(".banner-loyalty").slideUp();
        sessionStorage.setItem("show_top_banner", JSON.stringify(Date.now() + expiration * 1000));
    });
    $(".logout-link").click(function () {
        if (sessionStorage.getItem("show_top_banner") !== null) {
            sessionStorage.removeItem("show_top_banner");
        }
    });

    $(".navbar-toggler").on("click", function (e) {
        e.preventDefault();
        $("body").toggleClass("in");
        $(".header-content").toggleClass("fixed-header-content");
        $(".header.container").toggleClass("fixed-header-container");
    });
    $(".billing-address-block .btn-add-new").on("click", function (e) {
        e.preventDefault();
        $(".billing-address-block").find("#savedAddress").val("").removeAttr("readonly").trigger("change");
    });
    $(".billing-address-block .btn-show-details").on("click", function (e) {
        e.preventDefault();
        var selectTextBilling;
        selectTextBilling = $(".address-selector-block .select2-selection__rendered").text().trim();
        $("#savedAddress").val("").trigger("change");
        $("#savedAddress").val(selectTextBilling).trigger("change");
        $("#billingAddressSelector").on("select2:select", function () {
            selectTextBilling = $(".address-selector-block .select2-selection__rendered").text().trim();
            $("#savedAddress").val("").trigger("change");
            $("#savedAddress").val(selectTextBilling).trigger("change");
        });
    });


    /* PAGE DESIGNER */
    /* editorialText widget order mobile mobileGrid2r1c */
    $(".mobile-2r-1c .experience-commerce_assets-editorialText").closest(".region.col-12.col-sm-6").addClass("order-1-mobile");

    var maxlengthtext = 96;
    $(".experience-commerce_assets-imageAndText .ITC-text-underneath p").text(function (_, text) {
        return $.trim(text).substring(0, maxlengthtext);
    });

    /* Phone AdressBook Formating */
    function format(s) {
        return s.toString().replace(/\d{2}(?=.)/g, "$& ");
    }

    $(".card-body .phone-adressbook").each(function() {
        let currentAddressPhone = $(this).text();
        let formattedAddressPhone = format(currentAddressPhone);
        $(this).text(formattedAddressPhone);
    });

    $(".edit-profile-form .form-control[required],.edit-profile-form input[type='email'],.edit-profile-form input[type='password']").each(function () {
        $(this).on("keyup", function () {
            if (!$(this).val()) {
                $(this).closest(".edit-profile-form").find(("button[type='submit']")).addClass("disabled");
            } else {
                $(this).closest(".edit-profile-form").find(("button[type='submit']")).removeClass("disabled");
            }
        });
    });
    if ($("#select2-billingAddressSelector-container").attr("title")) {
        var savedAddressBilling = $("#select2-billingAddressSelector-container").attr("title");
        $(".billing-address").find("#savedAddress").val(savedAddressBilling.trim());
    }

    $(".change-password-form input[type='password']").on("keyup", function () {
        var invalid= 0;
        $(".change-password-form input[type='password']:required").each(function () {
            if ($(this).val() == "") {
                invalid++;
            }
        });
        if (invalid<1) {
            $(".change-password-form .btn-save").removeClass("disabled");
        }
        else {
            $(".change-password-form .btn-save").addClass("disabled");
        }
    });

    $(".reset-password-form input[type='password']").on("keyup", function () {
        var invalid= 0;
        $(".reset-password-form input[type='password']:required").each(function () {
            if ($(this).val() == "") {
                invalid++;
            }
        });
        if (invalid<1) {
            $(".reset-password-form .btn-save").removeClass("disabled");
        }
        else {
            $(".reset-password-form .btn-save").addClass("disabled");
        }
    });

    $(".mobile-2r-1c  .experience-commerce_assets-contentTile").find(".content-tile-description > p").each(function () {
        if ($(this).val() === "") {
            $(this).remove();
        }
    });

    $(".newsletter-form input[type='email']").on("keyup", function () {
        if ($(this).val() == "") {
            $(".btn-submit").addClass("disabled");
        }
        else {
            $(".btn-submit").removeClass("disabled");
        }
    });

    autosizearea();
    function autosizearea() {
        var text = $(".autosizearea");

        text.each(function() {
            $(this).attr("rows", 1);
            resize($(this));
        });

        text.on("input", function() {
            resize($(this));
        });

        function resize ($text) {
            $text.css("height", "auto");
            $text.css("height", $text[0].scrollHeight+"px");
        }
    }

    $("textarea.autosizearea").keyup(function() {
        var $textarea = $(this);
        var characterCount = $textarea.val().length;
        var current = $("#current");
        var descriptionMaxLength = parseInt($textarea.attr("maxlength"), 10);
        var $descriptionCounter = $("#the-count");

        current.text(characterCount);

        // When 10 or less characters remain available, set the aria-live attribute to polite to announce the remaining characters to screen reader users
        if (descriptionMaxLength - characterCount <= 10) {
            $descriptionCounter.attr("aria-live", "polite");
        } else {
            $descriptionCounter.attr("aria-live", "off");
        }
    });

    $(".product-infos").find(".cart-and-ipay").each(function() {
        let $this = $(this);

        if ($this.data("is-instock") === true) {
            let $quantityWrapper = $this.closest(".product-infos").find(".quantity");
            let $quantityPdp = $quantityWrapper.find(".quantity-pdp");
            let $quantitySelect = $quantityWrapper.find(".quantity-select");

            $quantityPdp.addClass("quantity-pdp-disabled");
            $quantitySelect.addClass(".quantity-select-disabled").prop("disabled", true);
            $quantitySelect.html("").select2({ data: [{ id: "0", text: "0" }] });
        }
    });

});

$(".registration input").on("change keyup", function () {
    var invalid= 0;

    $(".registration input:required").each(function () {
        if (!$("#accept-terms-conditions")[0].checked || $(this).val() == "" || $(".registered-day .select2-selection__placeholder").text()==$(".registered-day #register-day").data("placeholder") || $(".registered-month .select2-selection__placeholder").text()==$(".registered-month #register-month").data("placeholder") || $(".registered-year .select2-selection__placeholder").text()==$(".registered-year #register-year").data("placeholder") || $(".register-country-of-residence .select2-selection__placeholder").text()==$(".register-country-of-residence #countryOfResidence").data("placeholder")) {
            invalid++;
        }
    });
    if (invalid<1) {
        $(".registration-submit-btn").removeClass("disabled").removeAttr("disabled");
    }
    else {
        $(".registration-submit-btn").addClass("disabled").attr("disabled", true);
    }
});
$("#register-day,#register-month,#register-year,#countryOfResidence").on("change select2:select", function () {
    var invalid= 0;

    $(".registration input:required").each(function () {
        if (!$("#accept-terms-conditions")[0].checked || $(this).val() == "" || $(".registered-day .select2-selection__placeholder").text()==$(".registered-day #register-day").data("placeholder") || $(".registered-month .select2-selection__placeholder").text()==$(".registered-month #register-month").data("placeholder") || $(".registered-year .select2-selection__placeholder").text()==$(".registered-year #register-year").data("placeholder") || $(".register-country-of-residence .select2-selection__placeholder").text()==$(".register-country-of-residence #countryOfResidence").data("placeholder")) {
            invalid++;
        }
    });
    if (invalid<1) {
        $(".registration-submit-btn").removeClass("disabled").removeAttr("disabled");
    }
    else {
        $(".registration-submit-btn").addClass("disabled").attr("disabled", true);
    }

});

$(document).on("change keyup", ".required-contact", function() {
    let Disabled = true;
    $(".required-contact").each(function() {
        let value = this.value;
        if ((value)&&(value.trim() !="")) {
            Disabled = false;
        } else {
            Disabled = true;
            return false;
        }
    });

    if (Disabled) {
        $(".toggle-disabled").addClass("disabled");
    } else {
        $(".toggle-disabled").removeClass("disabled");
    }

    /* Age gate check */
    if ($(".page-age-gate")[0]) {
        $("body").addClass("overflow-hidden");
    }
});

if ($(".page-age-gate")[0] && !$(".page-age-gate").hasClass("d-none")) {
    $("body").addClass("overflow-hidden");
}

// country Selector Language
if ($(".country-selector-link")[0]) {
    $(".country-selector-link").text($("#countrySelectorCountry :selected").text().trim() + " | " + $("#countrySelectorLanguage :selected").val());
}

topBannerShow();
function topBannerShow() {
    var showTopBanner = sessionStorage.getItem("show_top_banner");

    if (Date.now() > JSON.parse(showTopBanner)) {
        $(".banner-loyalty").removeClass("d-none");
        sessionStorage.removeItem("show_top_banner");
    }
}

/** color categorie loyolty */

$(".navbar .menu-group .nav-item").hover(function() {
    var border_pl= $(this).attr("data-color-cat");
    if (border_pl !== "" && border_pl) {
        $(this).children().children(".nav-link__text").css("border-color", border_pl);
    }
}, function() {
    $(this).children().children(".nav-link__text").css("border-color", "");
});

// change opacity the product out of stock on plp
$(document).ajaxComplete(function() {
    if ($(".js-plp-tile")[0]) {
        $(".product-grid>div").each(function() {
            if ($(this).find(".add-to-card-cta").hasClass("grayedout")) {
                $(this).addClass("grayed");
            }
        });

        showImageProductPLP();
    }
});

showImageProductPLP();
function showImageProductPLP() {
    // hides the first image of product
    $(".product-tile .tile-img-second").on("mouseenter", function() {
        $(this).parent().children(":first").hide();
    }).on("mouseleave", function() {
        $(this).parent().children(":first").show();
    });
}

$(window).scroll(function() {
    if (/iPhone/i.test(navigator.userAgent) && (($(window).scrollTop() + $(window).height() + 600) >= $(document).height())) {
        // Code to execute if the user is using an iPhone
        $("body").addClass("nopadding");
    }
});

$(".input.contact-us-subject").on("change", function() {
    if ($(".input.contact-us-subject option:selected").attr("data-order") == "true") {
        $("input#contact-order-number").prop("required", true);
    } else {
        $("input#contact-order-number").prop("required", false);
    }
});

var lang = $("html").attr("lang");

$(".contactUs .select2-hidden-accessible").select2({
    minimumResultsForSearch: -1,
    language: lang,
    escapeMarkup: function(markup) {
        return markup;
    }
});
